module.exports = __webpack_public_path__ + "img/two.609baa45.png";